export default class BatchViewHtml {
    #DEFAULT_DISPLAY_OPTIONS = {
        isLoading: true,
        activeView: 'plates',
        isVisible: true,
    }
    #displayOptions;
    #root;
    #callbacks = {
        onViewChanged: [],
    }
    #menuUnderlay;

    constructor(rootElement, displayOptions) {
        this.#root = rootElement;
        this.#displayOptions = Object.assign({}, this.#DEFAULT_DISPLAY_OPTIONS, displayOptions);
    }

    show() {
        if (this.#root.querySelector('.batch-view') == null)
            this.#render();
    }

    /** @return {HTMLElement} */
    getPlateViewRootElement() {
        return this.#root.querySelector('.batch-view__plates');
    }

    /** @return {HTMLElement} */
    getTableViewRootElement() {
        return this.#root.querySelector('.batch-view__table');
    }

    setDisplayOptions(displayOptions) {
        Object.assign(this.#displayOptions, displayOptions);
        const {isLoading, activeView, isVisible} = this.#displayOptions;

        const componentElement = this.#root.querySelector('.batch-view');
        componentElement.classList.toggle('visually-hidden', !isVisible);

        const previewElement = this.#root.querySelector('.batch-view__preview');
        previewElement.classList.toggle('batch-view__preview-plate', activeView === 'plates');
        previewElement.classList.toggle('batch-view__preview-table', activeView === 'table');
        previewElement.classList.toggle('visually-hidden', !isLoading);

        const contentElement = this.#root.querySelector('.batch-view__content');
        contentElement.classList.toggle('visually-hidden', isLoading);

        const platesContainer = document.querySelector('.batch-view__plates');
        platesContainer.classList.toggle('visually-hidden', isLoading || activeView !== 'plates');
        const tableContainer = document.querySelector('.batch-view__table');
        tableContainer.classList.toggle('visually-hidden', isLoading || activeView !== 'table');

        const changeViewIcon = this.#root.querySelector('.material-symbols-outlined[data-name="change-view"]');
        changeViewIcon.textContent = activeView === 'plates' ? 'table' : 'apps';
        changeViewIcon.classList.toggle('white-background', activeView === 'table');
    }

    onChangeView(callback) {
        this.#callbacks.onViewChanged.push(callback);
    }

    #render() {
        this.#root.insertAdjacentHTML('beforeend', this.#htmlTemplate());
        this.#root.querySelector('.material-symbols-outlined[data-name="change-view"]').addEventListener('click', (event) => {
            this.#callbacks.onViewChanged.forEach(callback => callback());
        });
    }

    #htmlTemplate() {
        const {isLoading, activeView, isVisible} = this.#displayOptions;
        const plateVisibilityClass = activeView === 'plates' ? '' : 'visually-hidden';
        const tableVisibilityClass = activeView === 'table' ? '' : 'visually-hidden';
        const previewClass = activeView === 'plates' ? 'batch-view__preview-plate' : 'batch-view__preview-table';
        const previewVisibilityClass = isLoading ? '' : 'visually-hidden';
        const changeViewIcon = activeView === 'plates' ? 'table' : 'apps';
        const changeViewIconClass = activeView === 'table' ? 'white-background' : '';
        const componentVisibilityClass = isVisible ? '' : 'visually-hidden';

        return `
            <div class="batch-view ${componentVisibilityClass}">
                <div class="batch-view__preview ${previewClass} ${previewVisibilityClass}">
                    <div class="dancing-bars"></div>
                </div>
                <div class="batch-view__content">
                    <div class="batch-view__plates ${plateVisibilityClass}"></div>
                    <div class="batch-view__table ${tableVisibilityClass}"></div>
                    <span class="material-symbols-outlined ${changeViewIconClass}"
                          data-name="change-view" 
                          title="Toggle batch injections display: plates or table">${changeViewIcon}</span>
                </div>
                </div>              
            </div>`
    }
}